import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import type { Size } from '../../../orders/order.model';

export type SizeGlyphSize = 'sm' | 'md';

const BOX = {
  sm: 'size-5',
  md: 'size-8',
} as const satisfies Record<SizeGlyphSize, string>;

/**
 * Outline rectangle in the print's aspect ratio (always portrait), so sizes are
 * recognisable at a glance. `dimensions === null` renders the "All sizes" stack.
 */
@Component({
  selector: 'app-size-glyph',
  templateUrl: './size-glyph.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'inline-flex shrink-0 items-center justify-center' },
})
export class SizeGlyphComponent {
  readonly dimensions = input.required<Pick<Size, 'width' | 'height'> | null>();
  readonly size = input<SizeGlyphSize>('md');
  readonly active = input(false);

  protected readonly box = computed(() => BOX[this.size()]);

  // Portrait rectangle filling the full height; width follows the aspect ratio.
  protected readonly widthPercent = computed(() => {
    const dimensions = this.dimensions();
    if (!dimensions) return 100;
    const { width, height } = dimensions;
    return (Math.min(width, height) / Math.max(width, height)) * 100;
  });
}
